import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { actions, Types } from "../state";
import { actions as authActions } from "../../auth/state";
import { callApi, callSsoApi } from "../../../common/util/api";
import { makeFetchSaga } from "../../../common/util/fetch";

function* fetchCreateProfileImg({ formData }) {
  const { isSuccess, data } = yield call(callSsoApi, {
    url: "/auth/profile/image",
    method: 'patch',
    data: formData,
  });
  if (isSuccess && data) {
    const currentUser = yield select(state => state.auth.user);
    yield put(authActions.setValue({ key: "user", value: { ...currentUser, profileImg: data.profileImageUrl } }));
    yield put(actions.setValue({ key: "profileImg", value: data.profileImageUrl }));
  }
}

function* fetchDeleteProfileImg() {
  const { isSuccess } = yield call(callSsoApi, {
    url: "/auth/profile/image",
    method: 'delete',
  });
  if (isSuccess) {
    const currentUser = yield select(state => state.auth.user);
    yield put(authActions.setValue({ key: "user", value: { ...currentUser, profileImg: null } }));
    yield put(actions.setValue({ key: "profileImg", value: null }));
  }
}

function* fetchUpdateNickName({ nickName }) {
  const { isSuccess, data } = yield call(callApi, {
    url: "/user/nickname",
    method: 'patch',
    data: { nickName }
  });
  if (isSuccess && data) {
    yield put(authActions.setValue({key: "user", value: data}));
  }
}

function* fetchUpdateCommentNoticeYsno({ commentNoticeYsno }) {
  const { isSuccess, data } = yield call(callApi, {
    url: "/user/commentNoticeYsno",
    method: 'patch',
    data: { commentNoticeYsno }
  });
  if (isSuccess && data) {
    yield put(authActions.setValue({key: "user", value: data}));
  }
}

function* fetchUpdateNewPostNoticeYsno({ newPostNoticeYsno }) {
  const { isSuccess, data } = yield call(callApi, {
    url: "/user/newPostNoticeYsno",
    method: 'patch',
    data: { newPostNoticeYsno }
  });
  if (isSuccess && data) {
    yield put(authActions.setValue({key: "user", value: data}));
  }
}

function* fetchSignOutUser() {
  yield call(callApi, {
    url: "/auth/signout",
    method: 'patch',
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function* () {
  yield all([
    takeEvery(
      Types.FetchCreateProfileImg,
      makeFetchSaga({ fetchSaga: fetchCreateProfileImg, canCache: false })
    ),
    takeEvery(
      Types.FetchDeleteProfileImg,
      makeFetchSaga({ fetchSaga: fetchDeleteProfileImg, canCache: false })
    ),
    takeEvery(
      Types.FetchUpdateNickName,
      makeFetchSaga({ fetchSaga: fetchUpdateNickName, canCache: false })
    ),
    takeEvery(
      Types.FetchUpdateCommentNoticeYsno,
      makeFetchSaga({ fetchSaga: fetchUpdateCommentNoticeYsno, canCache: false })
    ),
    takeEvery(
      Types.FetchUpdateNewPostNoticeYsno,
      makeFetchSaga({ fetchSaga: fetchUpdateNewPostNoticeYsno, canCache: false })
    ),
    takeEvery(
      Types.FetchSignOutUser,
      makeFetchSaga({ fetchSaga: fetchSignOutUser, canCache: false })
    ),
  ]);
}
